import * as React from "react";
import { connect } from "react-redux";
import { init } from "./actions.js";
import { createApiConfig } from "./create-api-config.js";
const ApiConfigContext = React.createContext(null);
function assertApiConfig(apiConfig) {
  if (apiConfig === null || apiConfig === void 0) {
    throw new Error(
      "Missing API config provider. You have to wrap the application with the ApiConfigProvider component from the @grandvisionhq/state package."
    );
  }
}
const ApiConfigProvider = (props) => {
  React.useEffect(() => {
    props.init(createApiConfig(props.apiConfig));
  }, [JSON.stringify(props.apiConfig)]);
  return /* @__PURE__ */ React.createElement(ApiConfigContext.Provider, { value: createApiConfig(props.apiConfig) }, props.children);
};
function withApiConfig(Component) {
  const wrappedName = Component.displayName || Component.name || "Component";
  const WithApiConfig = (props) => /* @__PURE__ */ React.createElement(ApiConfigContext.Consumer, null, (apiConfig) => {
    assertApiConfig(apiConfig);
    return /* @__PURE__ */ React.createElement(Component, { ...props, apiConfig });
  });
  WithApiConfig.displayName = `WithApiConfig(${wrappedName})`;
  return WithApiConfig;
}
function useApiConfig() {
  const context = React.useContext(ApiConfigContext);
  if (context === null) {
    throw new Error(
      "Missing API config provider. You have to wrap the application with the ApiConfigProvider component from the @grandvisionhq/state package."
    );
  }
  return context;
}
const mapDispatchToProps = {
  init
};
const ApiConfig = connect(null, mapDispatchToProps)(ApiConfigProvider);
export {
  ApiConfigContext,
  ApiConfigProvider,
  assertApiConfig,
  ApiConfig as default,
  mapDispatchToProps,
  useApiConfig,
  withApiConfig
};
//# sourceMappingURL=ApiConfig.js.map
